/** Visual movement only. Collision, AI and saved character state stay independent. */
export type MotionGait = 'walk' | 'run' | 'sneak';
export interface CharacterMotion {
  phase: number;
  strength: number;
  gait: MotionGait;
}
export const STRIDE_LENGTH: Record<MotionGait, number> = { walk: 46.4, run: 48, sneak: 36 };
export function createMotion(gait: MotionGait = 'walk'): CharacterMotion {
  return { phase: 0.25, strength: 0, gait };
}

/** Advance by distance travelled, so faster friends and collision sliding don't skate. */
export function advanceMotion(m: CharacterMotion, distance: number, gait: MotionGait, dt: number): void {
  if (dt <= 0) return;
  const walking = distance > 0.001;
  if (walking) {
    m.gait = gait;
    m.phase = (m.phase + distance / STRIDE_LENGTH[gait]) % 1;
  } else if (m.strength > 0) {
    // Return to the next passing pose while easing the stride down, never snap to idle.
    const target = m.phase < 0.25 ? 0.25 : m.phase < 0.75 ? 0.75 : 1.25;
    m.phase = (m.phase + Math.min(target - m.phase, dt * 1.8)) % 1;
  } else m.gait = gait;
  m.strength += ((walking ? 1 : 0) - m.strength) * (1 - Math.exp(-dt * (walking ? 20 : 14)));
  if (m.strength < 0.02) { m.strength = 0; m.phase = 0.25; m.gait = gait; }
}
